import React from 'react'
import LayoutDesign from '../components/design/LayoutDesign'
import { connect } from "react-redux";

function Design({resumeReducer}) {
  return (
    <>
      <div className='mt-5'>
        <LayoutDesign/>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps, null)(Design)